import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import { RootState } from '../../../reducers';
import * as actionsJourney from '../../../actions/journey1';
import BreadCrumbs from '../../../components/BreadCrumbs';
import * as actions from '../../../actions/index';
import { Button, EButtonType } from '@repo/apg-ui';
import './Railposter.scss';
import { useNavigate } from 'react-router';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';

interface Props {
  locales: any;
  intl: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  actionsJourney: any;
  history: any;
}

const RailPoster = (props: Props) => {
  const navigate = useNavigate();

  return (
    <>
      <BreadCrumbs
        parentPage={null}
        pageName={props.intl.formatMessage({
          id: 'ec.navigation.railPosters',
          defaultMessage: 'RailPosters',
        })}
      />
      <div className='container-fluid journey1 overflow-hidden rail-posters p-0'>
        <div className='pageContainer'>
          <div className='service'>
            <div className='row justify-content-start'>
              <h3 className='col-12 fw-bold mb-20 ps-0'>
                <FormattedMessage
                  id='as.railposters.title'
                  defaultMessage='Druck-Service für Hängekartons und RailPosters'
                />
              </h3>

              <p className='mt-2 mb-20 col-8 ps-0'>
                <FormattedMessage
                  id='as.railposters.sub-title'
                  defaultMessage='Lassen Sie Ihr Hängekarton- und /oder RailPoster-Sujet über das Portal trafficposter.ch drucken.'
                />
              </p>

              <p className='col-8 mb-4 ps-0'>
                <FormattedMessage
                  id='as.railposters.third-title'
                  defaultMessage='Sie haben bereits einen druckfertigen Hängekarton oder ein druckfertiges RailPoster-Sujet und möchten es drucken lassen?'
                />
              </p>

              <p className='col-12 mb-24 ps-0'>
                <FormattedMessage id='as.railposters.unserPartner' defaultMessage='Unser Partner:' />
              </p>

              <p className='col-12 m-0 ps-0'>Vögeli AG Langenau i.E.</p>

              <p className='col-12 m-0 ps-0'>Marketingproduktion & Druck</p>

              <p className='col-12 m-0 ps-0'>Sögestrasse 21-23</p>

              <p className='col-12 mb-24 ps-0'>CH-3550 Langenau</p>

              <p className='col-12 m-0 ps-0'>T: +41 (0)34 409 10 10</p>

              <p className='col-12 m-0 ps-0'>F: +41 (0)34 409 10 15</p>

              <p className='col-8 mt-24 mb-3 ps-0'>
                <FormattedMessage
                  id='as.railposters.paragraph'
                  defaultMessage='bietet Ihnen unter dem Portal trafficposter.ch eine optimale Gestaltungs- und Produktionsmöglichkeit.'
                />
              </p>
            </div>

            <div className='row justify-content-start'>
              <div className='col-9 d-flex twoButtons ps-0'>
                <Button
                  onClick={() => navigate({ pathname: '/dashboard' })}
                  buttonType={EButtonType.InvertedPillMedium}
                >
                  <FormattedMessage id='ec.components.buttons.back' defaultMessage='Zurück' />
                </Button>

                <Button href={`http://www.trafficposter.ch/`} buttonType={EButtonType.PillMedium}>
                  <FormattedMessage id='ec.components.buttons.confirm' defaultMessage='Bestätigen' />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsJourney: bindActionCreators(actionsJourney as any, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(RailPoster)));
